import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from 'vue-router'
// import routes from "./routes";
import PageView from '@/views/PageView'
import HomePage from '@/views/HomePage'
import Pay from '@/views/Pay'
import OnlineStore from '@/views/OnlineStore'
import PayDetail from '@/views/PayDetail'
import LiveDetail from '@/views/LiveDetail'


const router = createRouter({
	// history: createWebHashHistory(), //修改后
	history: createWebHashHistory(process.env.BASE_URL), //带#
	// history: createWebHistory(process.env.BASE_URL),//不带# 但是刷新就404

	routes: [
		{
			path: '/',
			redirect: '/home'
		}, {
			path: '/home',
			name: 'home',
			component: HomePage,
		}, {
			path: '/pay',
			name: 'pay',
			component: Pay,
		},
		{
			path: '/online_store',
			name: 'onlineStore',
			component: OnlineStore,
		},
		{
			path: '/pay_detail',
			name: 'PayDetail',
			component: PayDetail,
		},
		{
			path: '/Live_detail',
			name: 'liveDetail',
			component: LiveDetail,
		},
	],

	// routes: [{
	// 	path: '/',
	// 	redirect: '/home'
	// }, {
	// 	path: '/',
	// 	name: 'PageView',
	// 	component: PageView,
	// 	children: [{
	// 		path: '/home',
	// 		name: 'home',
	// 		component: HomePage,
	// 	}, {
	// 		path: '/pay',
	// 		name: 'pay',
	// 		component: Pay,
	// 	}]
	// }],

	scrollBehavior(to, from, savedPosition) {
		return {
			top: 0
		}
	}

})

router.beforeEach((to,from,next) => {
	if(to.path == '/') {
		next('/home')
	} else {
		next();
	}
})
export default router
